// extracted by mini-css-extract-plugin
export default {"box":"style--box--1795a3","separated":"style--separated--f1d4f6"};